import React from 'react';
import GrillType from '../../controls/grill/GrillType';
import GrillSize from '../../controls/grill/GrillSize';
import GrillPattern from '../../controls/grill/GrillPattern';
import HorizontalGrills from '../../controls/grill/HorizontalGrills';
import VerticalGrills from '../../controls/grill/VerticalGrills';

export const getGrillsSection = (props) => {
  const {
    isDisabled,
    mainRowConfValue,
    windowTypeValue1,
    windowTypeValue2,
    windowTypeValue3,
    windowTypeValue4,
    windowTypeValue5,
    grillTypeValue1, setGrillTypeValue1,
    grillSizeValue1, setGrillSizeValue1,
    grillPatternValue1, setGrillPatternValue1,
    horizontalGrillsValue1, setHorizontalGrillsValue1,
    verticalGrillsValue1, setVerticalGrillsValue1,
    grillTypeValue2, setGrillTypeValue2,
    grillSizeValue2, setGrillSizeValue2,
    grillPatternValue2, setGrillPatternValue2,
    horizontalGrillsValue2, setHorizontalGrillsValue2,
    verticalGrillsValue2, setVerticalGrillsValue2,
    grillTypeValue3, setGrillTypeValue3,
    grillSizeValue3, setGrillSizeValue3,
    grillPatternValue3, setGrillPatternValue3,
    horizontalGrillsValue3, setHorizontalGrillsValue3,
    verticalGrillsValue3, setVerticalGrillsValue3,
    grillTypeValue4, setGrillTypeValue4,
    grillSizeValue4, setGrillSizeValue4,
    grillPatternValue4, setGrillPatternValue4,
    horizontalGrillsValue4, setHorizontalGrillsValue4,
    verticalGrillsValue4, setVerticalGrillsValue4,
    grillTypeValue5, setGrillTypeValue5,
    grillSizeValue5, setGrillSizeValue5,
    grillPatternValue5, setGrillPatternValue5,
    horizontalGrillsValue5, setHorizontalGrillsValue5,
    verticalGrillsValue5, setVerticalGrillsValue5,
  } = props;

  return [
    // Grills section starts ...
    (windowTypeValue1 !== "None") && (
    { id: "GrillType1",  component: 1 > mainRowConfValue ? null : ( <GrillType
      disabled={isDisabled} id = {"GrillType1"} label={"Grill Type 1"}
      value={grillTypeValue1}  onChange={(newValue) => { setGrillTypeValue1(newValue);}
    }/>),   position: [1, 1], status: "active", expandableSectionId: "Grills" }),

    (windowTypeValue1 !== "None") && !['None'].includes(grillTypeValue1?.value) &&
    { id: "GrillSize1",  component: 1 > mainRowConfValue ? null : ( <GrillSize
      disabled={isDisabled} id = {"GrillSize1"} label={"Grill Size"}
      grillTypeValue={grillTypeValue1?.value}
      value={grillSizeValue1}  onChange={(newValue) => { setGrillSizeValue1(newValue);}
    }/>),   position: [1, 2], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue1 !== "None") && !['None'].includes(grillTypeValue1?.value) &&
    { id: "GrillPattern1",  component: 1 > mainRowConfValue ? null : ( <GrillPattern
      disabled={isDisabled} id = {"GrillPattern1"} label={"Grill Pattern"} hideOptions = {['Rays']}
      grillTypeValue={grillTypeValue1?.value}
      grillSizeValue={grillSizeValue1}
      value={grillPatternValue1}  onChange={(newValue) => { setGrillPatternValue1(newValue);}
    }/>),   position: [1, 3], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue1 !== "None") &&
    !['None'].includes(grillTypeValue1?.value) && ['Colonial', 'No Grills'].includes(grillPatternValue1?.value) &&
    { id: "HorizontalGrills1",  component: 1 > mainRowConfValue ? null : ( <HorizontalGrills
      disabled={isDisabled} id = {"HorizontalGrills1"} label={"Horizontal lines"}
      value={horizontalGrillsValue1}  onChange={(newValue) => { setHorizontalGrillsValue1(newValue);}
    }/>),   position: [2, 1], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue1 !== "None") &&
    !['None'].includes(grillTypeValue1?.value) && ['Colonial', 'No Grills'].includes(grillPatternValue1?.value) &&
    { id: "VerticalGrills1",  component: 1 > mainRowConfValue ? null : ( <VerticalGrills
      disabled={isDisabled} id = {"VerticalGrills1"} label={"Vertical lines"}
      value={verticalGrillsValue1}  onChange={(newValue) => { setVerticalGrillsValue1(newValue);}
    }/>),   position: [2, 2], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue2 !== "None") && (
    { id: "GrillType2",  component: 2 > mainRowConfValue ? null : ( <GrillType
      disabled={isDisabled} id = {"GrillType2"} label={"Grill Type 2"}
      value={grillTypeValue2}  onChange={(newValue) => { setGrillTypeValue2(newValue);}
    }/>),   position: [3, 1], status: "active", expandableSectionId: "Grills" }),

    (windowTypeValue2 !== "None") && !['None'].includes(grillTypeValue2?.value) &&
    { id: "GrillSize2",  component: 2 > mainRowConfValue ? null : ( <GrillSize
      disabled={isDisabled} id = {"GrillSize2"} label={"Grill Size"}
      grillTypeValue={grillTypeValue2?.value}
      value={grillSizeValue2}  onChange={(newValue) => { setGrillSizeValue2(newValue);}
    }/>),   position: [3, 2], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue2 !== "None") && !['None'].includes(grillTypeValue2?.value) &&
    { id: "GrillPattern2",  component: 2 > mainRowConfValue ? null : ( <GrillPattern
      disabled={isDisabled} id = {"GrillPattern2"} label={"Grill Pattern"} hideOptions = {['Rays']}
      grillTypeValue={grillTypeValue2?.value}
      grillSizeValue={grillSizeValue2}
      value={grillPatternValue2}  onChange={(newValue) => { setGrillPatternValue2(newValue);}
    }/>),   position: [3, 3], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue2 !== "None") &&
    !['None'].includes(grillTypeValue2?.value) && ['Colonial', 'No Grills'].includes(grillPatternValue2?.value) &&
    { id: "HorizontalGrills2",  component: 2 > mainRowConfValue ? null : ( <HorizontalGrills
      disabled={isDisabled} id = {"HorizontalGrills2"} label={"Horizontal lines"}
      value={horizontalGrillsValue2}  onChange={(newValue) => { setHorizontalGrillsValue2(newValue);}
    }/>),   position: [4, 1], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue2 !== "None") &&
    !['None'].includes(grillTypeValue2?.value) && ['Colonial', 'No Grills'].includes(grillPatternValue2?.value) &&
    { id: "VerticalGrills2",  component: 2 > mainRowConfValue ? null : ( <VerticalGrills
      disabled={isDisabled} id = {"VerticalGrills2"} label={"Vertical lines"}
    value={verticalGrillsValue2}  onChange={(newValue) => { setVerticalGrillsValue2(newValue);}
    }/>),   position: [4, 2], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue3 !== "None") && (
    { id: "GrillType3",  component: 3 > mainRowConfValue ? null : ( <GrillType
      disabled={isDisabled} id = {"GrillType3"} label={"Grill Type 3"}
      value={grillTypeValue3}  onChange={(newValue) => { setGrillTypeValue3(newValue);}
    }/>),   position: [5, 1], status: "active", expandableSectionId: "Grills" }),

    (windowTypeValue3 !== "None") && !['None'].includes(grillTypeValue3?.value) &&
    { id: "GrillSize3",  component: 3 > mainRowConfValue ? null : ( <GrillSize
      disabled={isDisabled} id = {"GrillSize3"} label={"Grill Size"}
      grillTypeValue={grillTypeValue3?.value}
      value={grillSizeValue3}  onChange={(newValue) => { setGrillSizeValue3(newValue);}
    }/>),   position: [5, 2], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue3 !== "None") && !['None'].includes(grillTypeValue3?.value) &&
    { id: "GrillPattern3",  component: 3 > mainRowConfValue ? null : ( <GrillPattern
      disabled={isDisabled} id = {"GrillPattern3"} label={"Grill Pattern"} hideOptions = {['Rays']}
      grillTypeValue={grillTypeValue3?.value}
      grillSizeValue={grillSizeValue3}
      value={grillPatternValue3}  onChange={(newValue) => { setGrillPatternValue3(newValue);}
    }/>),   position: [5, 3], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue3 !== "None") &&
    !['None'].includes(grillTypeValue3?.value) && ['Colonial', 'No Grills'].includes(grillPatternValue3?.value) &&
    { id: "HorizontalGrills3",  component: 3 > mainRowConfValue ? null : ( <HorizontalGrills
      disabled={isDisabled} id = {"HorizontalGrills3"} label={"Horizontal lines"}
      value={horizontalGrillsValue3}  onChange={(newValue) => { setHorizontalGrillsValue3(newValue);}
    }/>),   position: [6, 1], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue3 !== "None") &&
    !['None'].includes(grillTypeValue3?.value) && ['Colonial', 'No Grills'].includes(grillPatternValue3?.value) &&
    { id: "VerticalGrills3",  component: 3 > mainRowConfValue ? null : ( <VerticalGrills
      disabled={isDisabled} id = {"VerticalGrills3"} label={"Vertical lines"}
    value={verticalGrillsValue3}  onChange={(newValue) => { setVerticalGrillsValue3(newValue);}
    }/>),   position: [6, 2], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue4 !== "None") && (
    { id: "GrillType4",  component: 4 > mainRowConfValue ? null : ( <GrillType
      disabled={isDisabled} id = {"GrillType4"} label={"Grill Type 4"}
      value={grillTypeValue4}  onChange={(newValue) => { setGrillTypeValue4(newValue);}
    }/>),   position: [7, 1], status: "active", expandableSectionId: "Grills" }),

    (windowTypeValue4 !== "None") && !['None'].includes(grillTypeValue4?.value) &&
    { id: "GrillSize4",  component: 4 > mainRowConfValue ? null : ( <GrillSize
      disabled={isDisabled} id = {"GrillSize4"} label={"Grill Size"}
      grillTypeValue={grillTypeValue4?.value}
      value={grillSizeValue4}  onChange={(newValue) => { setGrillSizeValue4(newValue);}
    }/>),   position: [7, 2], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue4 !== "None") && !['None'].includes(grillTypeValue4?.value) &&
    { id: "GrillPattern4",  component: 4 > mainRowConfValue ? null : ( <GrillPattern
      disabled={isDisabled} id = {"GrillPattern4"} label={"Grill Pattern"} hideOptions = {['Rays']}
      grillTypeValue={grillTypeValue4?.value}
      grillSizeValue={grillSizeValue4}
      value={grillPatternValue4}  onChange={(newValue) => { setGrillPatternValue4(newValue);}
    }/>),   position: [7, 3], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue4 !== "None") &&
    !['None'].includes(grillTypeValue4?.value) && ['Colonial', 'No Grills'].includes(grillPatternValue4?.value) &&
    { id: "HorizontalGrills4",  component: 4 > mainRowConfValue ? null : ( <HorizontalGrills
      disabled={isDisabled} id = {"HorizontalGrills4"} label={"Horizontal lines"}
      value={horizontalGrillsValue4}  onChange={(newValue) => { setHorizontalGrillsValue4(newValue);}
    }/>),   position: [8, 1], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue4 !== "None") &&
    !['None'].includes(grillTypeValue4?.value) && ['Colonial', 'No Grills'].includes(grillPatternValue4?.value) &&
    { id: "VerticalGrills4",  component: 4 > mainRowConfValue ? null : ( <VerticalGrills
      disabled={isDisabled} id = {"VerticalGrills4"} label={"Vertical lines"}
    value={verticalGrillsValue4}  onChange={(newValue) => { setVerticalGrillsValue4(newValue);}
    }/>),   position: [8, 2], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue5 !== "None") && (
    { id: "GrillType5",  component: 5 > mainRowConfValue ? null : ( <GrillType
      disabled={isDisabled} id = {"GrillTyp5e"} label={"Grill Type 5"}
      value={grillTypeValue5}  onChange={(newValue) => { setGrillTypeValue5(newValue);}
    }/>),   position: [9, 1], status: "active", expandableSectionId: "Grills" }),

    (windowTypeValue5 !== "None") && !['None'].includes(grillTypeValue5?.value) &&
    { id: "GrillSize5",  component: 5 > mainRowConfValue ? null : ( <GrillSize
      disabled={isDisabled} id = {"GrillSize5"} label={"Grill Size"}
      grillTypeValue={grillTypeValue5?.value}
      value={grillSizeValue5}  onChange={(newValue) => { setGrillSizeValue5(newValue);}
    }/>),   position: [9, 2], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue5 !== "None") && !['None'].includes(grillTypeValue5?.value) &&
    { id: "GrillPattern5",  component: 5 > mainRowConfValue ? null : ( <GrillPattern
      disabled={isDisabled} id = {"GrillPattern5"} label={"Grill Pattern"} hideOptions = {['Rays']}
      grillTypeValue={grillTypeValue5?.value}
      grillSizeValue={grillSizeValue5}
      value={grillPatternValue5}  onChange={(newValue) => { setGrillPatternValue5(newValue);}
    }/>),   position: [9, 3], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue5 !== "None") &&
    !['None'].includes(grillTypeValue5?.value) && ['Colonial', 'No Grills'].includes(grillPatternValue5?.value) &&
    { id: "HorizontalGrills5",  component: 5 > mainRowConfValue ? null : ( <HorizontalGrills
      disabled={isDisabled} id = {"HorizontalGrills5"} label={"Horizontal lines"}
      value={horizontalGrillsValue5}  onChange={(newValue) => { setHorizontalGrillsValue5(newValue);}
    }/>),   position: [10, 1], status: "active", expandableSectionId: "Grills" },

    (windowTypeValue5 !== "None") &&
    !['None'].includes(grillTypeValue5?.value) && ['Colonial', 'No Grills'].includes(grillPatternValue5?.value) &&
    { id: "VerticalGrills5",  component: 5 > mainRowConfValue ? null : ( <VerticalGrills
      disabled={isDisabled} id = {"VerticalGrills5"} label={"Vertical lines"}
    value={verticalGrillsValue5}  onChange={(newValue) => { setVerticalGrillsValue5(newValue);}
    }/>),   position: [10, 2], status: "active", expandableSectionId: "Grills" },

    // Grills ends ...
  ];
};
